<template>
    <div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
        <label class="col-md-3 control-label">{{controller.name}}</label>
        <div class="col-md-9">
            <textarea type="text" class="form-control" v-model="controller.value" @blur="controller.value = controller.value" rows="2"></textarea>
            <span class="help-block"  v-if="controller.hasWarning || controller.hasError" >
                <i class="fa"  v-bind:class="{ 'fa-exclamation-circle' : controller.hasError,'fa-exclamation-triangle' : controller.hasWarning }" ></i>
                <small>{{controller.message}}</small>
            </span>
        </div>
    </div>
</template>
<script>

    export default {
        props: ['controller'],
        data: function () {
            return {
                
            }
        },
        mounted: function () {
            //console.log("form element mounted")
            //console.log(this.controller)
        }
    }
</script>


// WEBPACK FOOTER //
// formtextarea.scp.html?b9937190